var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconModerate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.52393L11 13.5239L9 11.5239M20 10.689C20 17.2572 15.0319 20.202 12.9258 21.1553L12.9231 21.1565C12.7016 21.2567 12.5906 21.307 12.3389 21.3502C12.1795 21.3776 11.8215 21.3776 11.6621 21.3502C11.4094 21.3068 11.2972 21.2564 11.074 21.1553C8.9678 20.202 4 17.2572 4 10.689V6.72412C4 5.60402 4 5.04355 4.21799 4.61572C4.40973 4.2394 4.71547 3.93366 5.0918 3.74191C5.51962 3.52393 6.08009 3.52393 7.2002 3.52393H16.8002C17.9203 3.52393 18.4796 3.52393 18.9074 3.74191C19.2837 3.93366 19.5905 4.2394 19.7822 4.61572C20 5.04313 20 5.60292 20 6.72084V10.689Z",
    stroke: "#616161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModerate);
export default __webpack_public_path__ + "static/media/iconModerate.7403dfb0fcb183b71248bd2351bc4166.svg";
export { ForwardRef as ReactComponent };